// Photo zoom on the product page (owner 29.10.2026): a click on a photo of the gallery opens it full screen in
// PhotoSwipe 5 (white background, like the product photos) – zoom with a click, the wheel or two fingers, swipe or the
// arrows between the photos of the fabric shown. The 3D slide is left out. PhotoSwipe is loaded on the first click.
// The full-size picture and its real size come from snippets/product-zoom-data.liquid (inside the slide, so it follows
// the gallery when another fabric is picked); without it (old Accentuate galleries) the picture shown is used.
(() => {
  if (window.productZoom) return;   // the gallery can be on the page more than once – one listener is enough
  window.productZoom = true;
  const PSWP = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/';
  const T = {
    pl: ['Zamknij', 'Powiększ', 'Poprzednie', 'Następne', 'Nie udało się wczytać zdjęcia'],
    de: ['Schließen', 'Vergrößern', 'Zurück', 'Weiter', 'Das Bild konnte nicht geladen werden'],
    en: ['Close', 'Zoom', 'Previous', 'Next', 'The image could not be loaded'],
  };
  // the theme's own icons (snippets/svg.liquid: arrow_left / arrow_right as in the cart's "Uzupełnij zestaw", cross as the
  // cart's close button; owner 29.10)
  const ICON = (cls, d) => '<svg class="' + cls + '" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true">'
    + '<path fill="currentColor" d="' + d + '"/></svg>';
  const PREV = ICON('product-zoom__arrow', 'm2.69 10 7.56-7.56 1.06 1.06-5.75 5.75h10.69v1.5H5.56l5.75 5.75-1.06 1.06z');
  const NEXT = ICON('product-zoom__arrow', 'm17.31 10-7.56 7.56-1.06-1.06 5.75-5.75H3.75v-1.5h10.69L8.69 3.5l1.06-1.06z');
  const CLOSE = ICON('product-zoom__close', 'M18.03 3.03 11.06 10l6.97 6.97-1.06 1.06L10 11.06l-6.97 6.97-1.06-1.06L8.94 10 1.97 3.03l1.06-1.06L10 8.94l6.97-6.97z');
  let lib;
  const css = () => {
    if (document.getElementById('pswp-css')) return;
    const l = document.createElement('link');
    l.id = 'pswp-css'; l.rel = 'stylesheet'; l.href = PSWP + 'photoswipe.css';
    document.head.appendChild(l);
  };
  const photos = carousel => [...carousel.querySelectorAll('swiper-slide')]
    .filter(s => !s.classList.contains('has-model-element') && s.querySelector('img'));
  const item = s => {
    const img = s.querySelector('img'), z = s.querySelector('.product-zoom'), shown = img.currentSrc || img.src;
    return {
      src: (z && z.dataset.zoomSrc) || shown,
      width: +(z && z.dataset.zoomW) || img.naturalWidth || +img.getAttribute('width') || 1920,
      height: +(z && z.dataset.zoomH) || img.naturalHeight || +img.getAttribute('height') || 1080,
      msrc: shown,
      alt: img.alt || '',
    };
  };
  document.addEventListener('click', async e => {
    if (e.defaultPrevented || e.button) return;   // the carousel cancels the click after a swipe
    const slide = e.target.closest('product-media .main-carousel swiper-slide');
    if (!slide || slide.classList.contains('has-model-element') || !slide.querySelector('img')) return;
    const carousel = slide.closest('swiper-container'), list = photos(carousel), index = list.indexOf(slide);
    if (index < 0) return;
    e.preventDefault();
    css();
    lib = lib || import(PSWP + 'photoswipe.esm.min.js');
    const { default: PhotoSwipe } = await lib;
    const t = T[(document.documentElement.lang || 'pl').slice(0, 2)] || T.en;
    const pswp = new PhotoSwipe({
      dataSource: list.map(item), index, bgOpacity: 1, showHideAnimationType: 'fade',
      // no wrapping round, the arrow at the end greyed out (as in the cart); big arrows at the sides of the photo (as on
      // vetsak.com, owner 29.10) – room kept for them, on phones (no arrows, swiping) the photo uses the whole width
      loop: false, arrowPrevSVG: PREV, arrowNextSVG: NEXT, closeSVG: CLOSE,
      paddingFn: v => v.x < 768 ? { top: 64, bottom: 16, left: 0, right: 0 } : { top: 72, bottom: 24, left: 80, right: 80 },
      // zoom beyond the picture's own size too (the renders are 1920 px – fitting a big screen they could hardly zoom):
      // a click 2.5×, the wheel / two fingers up to 5×
      secondaryZoomLevel: z => z.fit * 2.5, maxZoomLevel: z => z.fit * 5,
      closeTitle: t[0], zoomTitle: t[1], arrowPrevTitle: t[2], arrowNextTitle: t[3], errorMsg: t[4],
    });
    // the gallery stays on the photo looked at last
    pswp.on('close', () => {
      const all = [...carousel.querySelectorAll('swiper-slide')], i = all.indexOf(list[pswp.currIndex]);
      if (carousel.swiper && i >= 0) carousel.swiper.slideTo(i, 0);
    });
    pswp.init();
  });
})();
